import { required } from '@origin-digital/validation';
import { AddressManualEntryValues } from './models';
import isEmpty from 'lodash/isEmpty';

export const notEmpty = (value?: string): boolean => value !== '' && value !== undefined;

/**
 * Validators stored in metadata are either stdlib validators
 * (`(...args: string[]) => string | void`) or the custom address
 * validators below, which take the full set of field values as the
 * second argument. This common shape covers both.
 */
export type AddressEntryValidator = (
  currentValue: string,
  allValues: AddressManualEntryValues
) => string | void;

export const reduceValidators = (
  currentValue: string,
  allValues: AddressManualEntryValues,
  validators: AddressEntryValidator[]
): string =>
  validators.reduce<string>((errorMessage, validator) => {
    if (!isEmpty(errorMessage)) {
      return errorMessage;
    }

    return validator(currentValue, allValues) || '';
  }, '');

export const validUnitType =
  ({ error }: { error: string }) =>
  (currentValue: string, { unitNumber }: AddressManualEntryValues) => {
    if (notEmpty(unitNumber)) {
      return required({ error })(currentValue);
    }
  };

export const validUnitNumber =
  ({ error }: { error: string }) =>
  (currentValue: string, { unitType }: AddressManualEntryValues) => {
    if (notEmpty(unitType)) {
      return required({ error })(currentValue);
    }
  };

export const validStreetNumberWithoutLot =
  ({ error }: { error: string }) =>
  (currentValue: string, { allotment }: AddressManualEntryValues) => {
    if (notEmpty(allotment)) {
      return;
    }

    if (!notEmpty(currentValue)) {
      return required({ error })(currentValue);
    }
  };

export const validLotNumber =
  ({ error }: { error: string }) =>
  (currentValue: string, { streetNumber }: AddressManualEntryValues) => {
    if (notEmpty(streetNumber) && notEmpty(currentValue)) {
      return error;
    }
  };
